import {
  AnyAction,
  applyMiddleware,
  combineReducers,
  createStore,
  Dispatch,
} from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import { fork } from 'redux-saga/effects';

import apiReducer from './api/reducer';
import { apiSagas, apiSagasWatcher } from './api/sagas';
import applicationReducer from './application/reducer';
import auditReducer from './audit/auditReducers';
import { auditSagas } from './audit/sagas';
import demnsReducers from './denm/denmsReducers';
import { denmsSagas } from './denm/sagas';
import devicesReducers from './devices/devicesReducers';
import { devicesSagas } from './devices/sagas';
import formReducer from './forms';
import ivimsReducers from './ivim/ivimsReducers';
import { ivimsSagas } from './ivim/sagas';
import pmvsReducers from './pmv/pmvsReducers';
import { pmvsSagas } from './pmv/sagas';
import roadsReducers from './roads/roadsReducers';
import { routesSagas } from './roads/sagas';
import camsReducer from './vehicles/vehiclesReducers';
import settingsReducer from './settings/settingsReducers';
import { settingsSaga } from './settings/sagas';
import spatemsReducers from './spatem/spatemsReducers';
import { spatemsSagas } from './spatem/spatemsSagas';

const sagaMiddleware = createSagaMiddleware();

function* rootSaga() {
  yield fork(apiSagas.saga);
  yield fork(apiSagasWatcher);
  yield fork(routesSagas.saga);
  yield fork(devicesSagas.saga);
  yield fork(pmvsSagas.saga);
  yield fork(denmsSagas.saga);
  yield fork(ivimsSagas.saga);
  yield fork(settingsSaga.saga);
  yield fork(spatemsSagas.saga);
  yield fork(auditSagas.saga);
}

const reducers = combineReducers({
  application: applicationReducer.reducer,
  api: apiReducer.reducer,
  forms: formReducer,
  denms: demnsReducers.reducer,
  ivims: ivimsReducers.reducer,
  roads: roadsReducers.reducer,
  devices: devicesReducers.reducer,
  pmvs: pmvsReducers.reducer,
  vehicles: camsReducer.reducer,
  settings: settingsReducer.reducer,
  spatems: spatemsReducers.reducer,
  audit: auditReducer.reducer,
});

const store = createStore(reducers, composeWithDevTools(applyMiddleware(sagaMiddleware)));

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = Dispatch<AnyAction>;
export const useAppDispatch = () => useDispatch<AppDispatch>();

export default store;
